import { type FC } from 'react';
import Lottie, { type Options } from 'react-lottie';
import confettiBurstAnimationData from './confetti_burst.json';

const ConfettiBurst: FC<{
  height?: number;
  width?: number;
  options?: Options;
}> = ({ height = 300, width = 300, options }) => (
  <Lottie
    options={{
      loop: false,
      autoplay: true,
      ...options,
      animationData: confettiBurstAnimationData,
    }}
    height={height}
    width={width}
  />
);

export default ConfettiBurst;
